<template>
  <div class="message-asign">
    <div class="choose-options">
      <el-select
        v-model="searchInfo.applyStatus"
        placeholder="请选择模板状态"
        clearable
      >
        <el-option
          v-for="item in applyOptions"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="searchInfo.categoryId"
        placeholder="请选择模板类型"
        clearable
      >
        <el-option
          v-for="item in templateOptions"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="searchInfo.sign"
        placeholder="请输入模板签名"
        clearable
      ></el-input>
      <el-button type="three" @click="getLists">筛选</el-button>
      <el-button type="three" @click="resetSearchInfo">重置</el-button>
    </div>
    <el-button type="three" size="medium" @click="add">新增模板</el-button>
    <el-table
      :data="templateList"
      style="width: 100%"
      :default-sort="{ prop: 'date', order: 'descending' }"
      :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
      }"
    >
      <el-table-column prop="templateId" label="模板ID" align="center"
        ><template slot-scope="scope"
          >{{ scope.row.templateId
          }}<el-tag v-if="scope.row.is_default == 2">默认模板</el-tag></template
        ></el-table-column
      >
      <el-table-column
        prop="template"
        label="模板内容"
        align="center"
      ></el-table-column>
      <el-table-column prop="applyStatus" label="状态" align="center"
        ><template slot-scope="scope">{{
          getStatusText(scope.row)
        }}</template></el-table-column
      >
      <el-table-column prop="categoryId" label="模板类型" align="center">
        <template slot-scope="scope">{{ getTemplateText(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="sign" label="模板签名" align="center"
        ><template slot-scope="scope">{{
          scope.row.sign.sign
        }}</template></el-table-column
      >
      <el-table-column
        prop="templateName"
        label="模板名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="save_time"
        label="添加时间"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <my-operation
            :scope="scope"
            @add="add"
            @deleteItem="deleteItem"
          ></my-operation>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :close-on-click-modal="false"
      :title="titleText"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :model="templateForm"
      width="800px"
    >
      <el-form
        status-icon
        label-width="120px"
        class="demo-ruleForm"
        :model="templateForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="模板名称：" prop="templateName">
          <el-input
            placeholder="请输入该模板的名称"
            class="input-with-select"
            v-model="templateForm.templateName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="模板类型：" prop="categoryId">
          <el-radio-group v-model="templateForm.categoryId" :disabled="!isAdd">
            <el-radio :label="2">通知型</el-radio>
            <el-radio :label="3">回复型</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板签名：" prop="signId">
          <el-select
            v-model="templateForm.signId"
            placeholder="请选择模板签名"
            clearable
          >
            <el-option
              v-for="item in signList"
              :key="item.id"
              :value="item.signId"
              :label="item.sign"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="模板描述：" prop="description">
          <el-input
            placeholder="请输入该模板的用途说明"
            class="input-with-select"
            v-model="templateForm.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="模板内容：" prop="template">
          <el-input
            placeholder="请输入该模板的内容"
            type="textarea"
            class="input-with-select"
            v-model="templateForm.template"
          >
          </el-input>
        </el-form-item>
        <el-form-item class="tips">
          <div>示例：你好你的验证码是{1}， 请在{2}分钟内使用</div>
        </el-form-item>
        <el-form-item label="设为默认" prop="is_default">
          <el-switch
            v-model="templateForm.is_default"
            :active-value="2"
            :inactive-value="1"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="handleClose">取消</el-button>
        <el-button size="medium" round type="primary" @click="vertifyConfirm"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { isSuccess } from '@/utils/index'
  import {
    APPLY_STATUS,
    APPLY_OPTIONS,
    APPLY_TEXT,
    TEMPLATE_TYPE,
  } from '@/utils/const'
  import {
    getTemplateList,
    addTemplate,
    deleteTemplate,
    getSignList,
  } from '@/api/messageManager'

  export default {
    components: {
      'my-operation': () => import('@/components/operation/index.vue'),
    },
    data() {
      return {
        templateList: [],
        deleteVisible: false,
        titleText: '新增模板',
        dialogVisible: false,
        searchInfo: {
          categoryId: '',
          applyStatus: '',
          sign: '',
        },
        templateOptions: [
          {
            label: TEMPLATE_TYPE.noticeText,
            value: TEMPLATE_TYPE.notice,
          },
          {
            label: TEMPLATE_TYPE.replyText,
            value: TEMPLATE_TYPE.reply,
          },
        ],
        applyOptions: APPLY_OPTIONS,
        templateForm: {
          templateName: '',
          template: '',
          signId: '',
          categoryId: TEMPLATE_TYPE.notice,
          is_default: 1,
          description: '',
        },
        isAdd: true,
        signList: [], // 签名列表
        rules: {
          templateName: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
          ],
          template: [
            { required: true, message: '请输入模板内容', trigger: 'blur' },
          ],
          signId: [
            { required: true, message: '请选择模板签名', trigger: 'change' },
          ],
          description: [
            { required: true, message: '请输入模板描述', trigger: 'blur' },
          ],
        },
      }
    },
    mounted() {
      this.getLists()
      this.getSignList()
    },
    computed: {
      getStatusText() {
        return (row) =>
          row.applyStatus == APPLY_STATUS.appling
            ? APPLY_TEXT.nocross
            : APPLY_TEXT.cross
      },
      getTemplateText() {
        return (row) =>
          row.categoryId == TEMPLATE_TYPE.notice
            ? TEMPLATE_TYPE.noticeText
            : TEMPLATE_TYPE.replyText
      },
    },
    methods: {
      async getLists() {
        const res = await getTemplateList(this.searchInfo)
        this.templateList = res.data
      },
      async getSignList() {
        const res = await getSignList({ applyStatus: 2 })

        this.signList = res.data
      },
      handleCurrentChange() {
        this.currentPage += 1
        this.getLists()
      },
      add(row) {
        this.isAdd = true
        if (row.id) {
          this.templateForm = { ...row, signId: row.sign.signId }
          this.titleText = '修改模板'
          this.isAdd = false
        }
        this.dialogVisible = true
      },
      handleClose() {
        this.templateForm = {
          templateName: '',
          template: '',
          is_default: 1,
          description: '',
          categoryId: TEMPLATE_TYPE.notice,
          signId: '',
        }
        this.dialogVisible = false
      },
      vertifyConfirm() {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            this.$message.error('信息不完整')
            return
          }
          this.confirm()
        })
      },
      async confirm() {
        let form = this.templateForm
        if (!this.isAdd) {
          form = {
            templateName: this.templateForm.templateName,
            template: this.templateForm.template,
            id: this.templateForm.id,
            is_default: this.templateForm.is_default,
            description: this.templateForm.description,
            categoryId: this.templateForm.categoryId,
            signId: this.templateForm.signId,
          }
        }
        const res = await addTemplate(form, this.isAdd)
        if (isSuccess(res.code)) {
          this.$message.success(`${this.isAdd ? '新增' : '修改'}成功`)
          this.handleClose()
          this.getLists()
          return
        }
      },
      async deleteItem(row) {
        const res = await deleteTemplate({
          id: row.id,
        })
        if (isSuccess(res.code)) {
          this.$message.success('删除成功')
          this.getLists()
          return
        }
      },
      resetSearchInfo() {
        this.searchInfo = {
          categoryId: '',
          applyStatus: '',
          sign: '',
        }
        this.getLists()
      },
    },
  }
</script>

<style lang="scss">
  .message-asign {
    // .el-input {
    //   width: 80%;
    // }
    .el-textarea {
      width: 80%;
    }
    .tips {
      margin: -15px 0 0 0;
      font-size: 14px;
      //   color: #555;
    }
  }
</style>
